import axios, { AxiosError, AxiosResponse } from 'axios'
import { toast } from 'react-hot-toast'

// Типы для API ошибок
export interface ApiError {
  detail: string
  status?: number | undefined
  alreadyToasted?: boolean
}

// Создаем экземпляр axios с базовой конфигурацией
export const apiClient = axios.create({
  baseURL: '', // Используем относительные URL, Express сервер проксирует на API_URL
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Отладка конфигурации (только один раз)
console.log('API Client initialized:', {
  baseURL: '(empty - using relative URLs via Express proxy)',
  timeout: 30000
})

// Interceptor для добавления токена аутентификации
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token')
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    return config
  },
  (error) => {
    console.error('Request interceptor error:', error)
    return Promise.reject(error)
  }
)

// Interceptor для обработки ошибок
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error: AxiosError) => {
    console.error('API Error:', error.response?.status, error.config?.url)
    console.error('Error details:', error.response?.data)
    
    const apiError: ApiError = {
      detail: (error.response?.data as any)?.detail || error.message || 'Произошла ошибка',
      status: error.response?.status,
    }

    // Если получили 401, токен недействителен
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token')
      window.location.href = '/login'
      toast.error('Сессия истекла. Войдите снова.')
      return Promise.reject(apiError)
    }

    // Показываем ошибку пользователю для клиентских ошибок
    if (error.response?.status && error.response.status >= 400 && error.response.status < 500) {
      toast.error(apiError.detail)
      apiError.alreadyToasted = true
    }

    return Promise.reject(apiError)
  }
)
